import React from 'react';
import { X, Plus, Minus, ShoppingBag, Trash2 } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { useNavigate } from 'react-router-dom';

export default function CartDrawer() {
  const { cart, open, setOpen, updateItem, removeItem } = useCart();
  const navigate = useNavigate();

  if (!open) return null;

  const firstImg = (imgs) => {
    try { const a = JSON.parse(imgs); return a[0] || null; } catch { return imgs; }
  };

  return (
    <>
      <div className="drawer-overlay" onClick={() => setOpen(false)} />
      <div className="cart-drawer">
        <div className="drawer-header">
          <div className="drawer-title">
            <ShoppingBag size={20} />
            Shporta ({cart.item_count})
          </div>
          <button className="drawer-close" onClick={() => setOpen(false)}><X size={20} /></button>
        </div>

        <div className="drawer-body">
          {cart.items.length === 0 ? (
            <div className="cart-empty">
              <ShoppingBag size={48} strokeWidth={1} />
              <p>Shporta juaj është bosh</p>
              <button className="btn btn-primary" onClick={() => { setOpen(false); navigate('/shop'); }}>
                Shfleto produktet
              </button>
            </div>
          ) : (
            <div className="cart-items">
              {cart.items.map(item => (
                <div key={item.id} className="cart-item">
                  <div className="cart-item-img">
                    {firstImg(item.images) ? (
                      <img src={firstImg(item.images)} alt={item.name} />
                    ) : <div className="img-placeholder">🌿</div>}
                  </div>
                  <div className="cart-item-info">
                    <div className="cart-item-name">{item.name}</div>
                    <div className="cart-item-size">{item.size}</div>
                    <div className="cart-item-price">${(item.price * item.quantity).toFixed(2)}</div>
                    <div className="cart-item-qty">
                      <button onClick={() => updateItem(item.id, item.quantity - 1)}><Minus size={14} /></button>
                      <span>{item.quantity}</span>
                      <button onClick={() => updateItem(item.id, item.quantity + 1)} disabled={item.quantity >= item.stock}><Plus size={14} /></button>
                    </div>
                  </div>
                  <button className="cart-item-remove" onClick={() => removeItem(item.id)}><Trash2 size={16} /></button>
                </div>
              ))}
            </div>
          )}
        </div>

        {cart.items.length > 0 && (
          <div className="drawer-footer">
            <div className="cart-subtotal">
              <span>Nëntotali</span>
              <span>${cart.subtotal?.toFixed(2)}</span>
            </div>
            {cart.subtotal < 49 && (
              <div className="free-shipping-note">
                Shtoni ${(49 - cart.subtotal).toFixed(2)} më shumë për dërgim falas! 🚚
              </div>
            )}
            <button className="btn btn-primary btn-full" onClick={() => { setOpen(false); navigate('/checkout'); }}>
              Vazhdo me pagesën →
            </button>
            <button className="btn btn-ghost btn-full" onClick={() => { setOpen(false); navigate('/cart'); }}>
              Shiko shportën
            </button>
          </div>
        )}
      </div>

      <style>{`
        .drawer-overlay { position:fixed;inset:0;background:rgba(0,0,0,.4);z-index:1100;backdrop-filter:blur(2px);animation:fadeIn .2s ease; }
        .cart-drawer { position:fixed;top:0;right:0;bottom:0;width:min(420px,100vw);background:var(--white);z-index:1101;display:flex;flex-direction:column;box-shadow:var(--shadow-lg);animation:slideIn .3s ease; }
        @keyframes slideIn { from{transform:translateX(100%)} to{transform:translateX(0)} }
        @keyframes fadeIn { from{opacity:0} to{opacity:1} }
        .drawer-header { display:flex;align-items:center;justify-content:space-between;padding:20px 24px;border-bottom:1px solid var(--cream-dark); }
        .drawer-title { display:flex;align-items:center;gap:10px;font-family:'Playfair Display',serif;font-size:1.1rem;font-weight:600; }
        .drawer-close { width:36px;height:36px;border-radius:50%;border:none;background:var(--cream);cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--text-mid);transition:all .2s; }
        .drawer-close:hover { background:var(--cream-dark); }
        .drawer-body { flex:1;overflow-y:auto;padding:16px; }
        .cart-empty { display:flex;flex-direction:column;align-items:center;gap:16px;padding:60px 24px;color:var(--text-light);text-align:center; }
        .cart-items { display:flex;flex-direction:column;gap:14px; }
        .cart-item { display:flex;gap:14px;align-items:flex-start;padding:14px;background:var(--cream);border-radius:var(--radius-md); }
        .cart-item-img { width:72px;height:80px;border-radius:var(--radius-sm);overflow:hidden;background:var(--white);flex-shrink:0;display:flex;align-items:center;justify-content:center; }
        .cart-item-img img { width:100%;height:100%;object-fit:contain; }
        .img-placeholder { font-size:1.8rem; }
        .cart-item-info { flex:1;min-width:0; }
        .cart-item-name { font-size:.88rem;font-weight:600;color:var(--green-deep);margin-bottom:2px; }
        .cart-item-size { font-size:.75rem;color:var(--text-light);margin-bottom:6px; }
        .cart-item-price { font-family:'Playfair Display',serif;font-size:1rem;font-weight:700;color:var(--green-deep);margin-bottom:8px; }
        .cart-item-qty { display:flex;align-items:center;gap:10px; }
        .cart-item-qty button { width:28px;height:28px;border-radius:50%;border:1.5px solid var(--green-soft);background:var(--white);cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--green-deep);transition:all .2s; }
        .cart-item-qty button:hover:not(:disabled) { background:var(--green-deep);color:white;border-color:var(--green-deep); }
        .cart-item-qty button:disabled { opacity:.4;cursor:not-allowed; }
        .cart-item-qty span { font-size:.9rem;font-weight:600;min-width:20px;text-align:center; }
        .cart-item-remove { width:32px;height:32px;border-radius:50%;border:none;background:transparent;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--text-light);transition:all .2s;flex-shrink:0; }
        .cart-item-remove:hover { background:var(--danger-soft);color:var(--danger); }
        .drawer-footer { padding:20px 24px;border-top:1px solid var(--cream-dark);display:flex;flex-direction:column;gap:12px; }
        .cart-subtotal { display:flex;justify-content:space-between;align-items:center;font-size:.95rem; }
        .cart-subtotal span:last-child { font-family:'Playfair Display',serif;font-size:1.2rem;font-weight:700; }
        .free-shipping-note { background:var(--green-soft);color:var(--green-deep);padding:10px 14px;border-radius:var(--radius-md);font-size:.8rem;font-weight:500;text-align:center; }
      `}</style>
    </>
  );
}
